import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
import {
  getTrackingDefaults,
  getClickCounts,
  incrementClickCounter,
  trackAction,
} from '../../../../shared/utils/tracking/datadogRumTracking';
import {
  TRACKING_526EZ_SIDENAV_BACK_BUTTON_CLICKS,
  TRACKING_526EZ_SIDENAV_CONTINUE_BUTTON_CLICKS,
} from '../../../constants';
import { isBDD } from '../../index';
import { getConditionsTransformProperties } from './conditionsWorkflowMigrationTracking';

// ──────────────────────────────────────────────
// Form navigation tracking
// ──────────────────────────────────────────────

export const trackBackButtonClick = () => {
  const { sourcePath, sidenav526ezEnabled } = getTrackingDefaults();
  incrementClickCounter(TRACKING_526EZ_SIDENAV_BACK_BUTTON_CLICKS);

  const properties = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    sourcePath,
    ...getClickCounts(),
  };

  if (sidenav526ezEnabled !== undefined) {
    properties.sidenav526ezEnabled = sidenav526ezEnabled;
  }

  trackAction('Form navigation - Back button clicked', properties);
};

export const trackContinueButtonClick = () => {
  const { sourcePath, sidenav526ezEnabled } = getTrackingDefaults();
  incrementClickCounter(TRACKING_526EZ_SIDENAV_CONTINUE_BUTTON_CLICKS);

  const properties = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    sourcePath,
    ...getClickCounts(),
  };

  if (sidenav526ezEnabled !== undefined) {
    properties.sidenav526ezEnabled = sidenav526ezEnabled;
  }

  trackAction('Form navigation - Continue button clicked', properties);
};

// ──────────────────────────────────────────────
// Form lifecycle tracking
// ──────────────────────────────────────────────

export const trackFormStarted = (formData = {}) => {
  const { sourcePath, sidenav526ezEnabled } = getTrackingDefaults();

  const properties = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    isBdd: isBDD(formData),
    sourcePath,
    ...getConditionsTransformProperties(formData),
    ...getClickCounts(),
  };

  if (sidenav526ezEnabled !== undefined) {
    properties.sidenav526ezEnabled = sidenav526ezEnabled;
  }

  trackAction('21-526EZ_claimStarted', properties);
};

export const trackFormResumption = (formData = {}) => {
  const { sourcePath, sidenav526ezEnabled } = getTrackingDefaults();

  const properties = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    sourcePath,
    ...getConditionsTransformProperties(formData),
    ...getClickCounts(),
  };

  if (sidenav526ezEnabled !== undefined) {
    properties.sidenav526ezEnabled = sidenav526ezEnabled;
  }

  trackAction('Form resumption - Saved form loaded', properties);
};

// ──────────────────────────────────────────────
// Entry gate error tracking
// ──────────────────────────────────────────────

export const trackAppEntered = (formData = {}) => {
  const { sourcePath } = getTrackingDefaults();
  trackAction('21-526EZ_app_entered', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    sourcePath,
    isBdd: isBDD(formData),
  });
};
